import { useEffect, useState } from "react"

export const useWindowWide = (size: Number) => {
    const [width, setWidth] = useState(0)

    useEffect(() => {
        handleResize()

        window.addEventListener("resize", handleResize)

        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [setWidth])

    const handleResize = () => {
        setWidth(window.innerWidth)
    }

    return width > size
}
